"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFortuneProductsApi = getFortuneProductsApi;
exports.updateFortuneProductsApi = updateFortuneProductsApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @description 获取产品配置
 */
function getFortuneProductsApi() {
  return (0, _request.default)({
    url: "admin/platform/fortune/product/getProducts",
    method: 'GET'
  });
}

/**
 * 保存产品配置
 */
function updateFortuneProductsApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/fortune/product/saveProducts',
    method: 'POST',
    data: data
  });
}